var map = {
	"./avatar-1.svg": 27204,
	"./avatar-10.svg": 52407,
	"./avatar-11.svg": 94467,
	"./avatar-12.svg": 70478,
	"./avatar-2.svg": 44976,
	"./avatar-3.svg": 32092,
	"./avatar-4.svg": 67203,
	"./avatar-5.svg": 92750,
	"./avatar-6.svg": 98976,
	"./avatar-7.svg": 66248,
	"./avatar-8.svg": 80588,
	"./avatar-9.svg": 79703,
	"./avatar-placeholder.svg": 89134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94854;